import { useState } from 'react';
import CountryList from '../../components/admin/countries/CountryList';
import CountryForm from '../../components/admin/countries/CountryForm';
import Button from '../../components/shared/UI/Button';

export default function CountriesPage() {
  const [view, setView] = useState('list');
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  function handleSaved() {
    setView('list');
    setSelectedCountry(null);
    setRefreshKey(k => k + 1);
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Countries & Currencies</h1>
          <p>Manage the country and currency registry used across all funds.</p>
        </div>
      </div>

      {view === 'list' && (
        <CountryList
          key={refreshKey}
          onAdd={() => { setSelectedCountry(null); setView('add'); }}
          onEdit={(country) => { setSelectedCountry(country); setView('edit'); }}
        />
      )}

      {(view === 'add' || view === 'edit') && (
        <div>
          <div style={{ marginBottom: 20 }}>
            <Button variant="ghost" onClick={() => { setView('list'); setSelectedCountry(null); }}>
              ← Back to Countries
            </Button>
          </div>
          <div className="card">
            <div className="card-header">
              <h2>{view === 'add' ? 'Add New Country' : `Edit: ${selectedCountry?.name}`}</h2>
            </div>
            <div className="card-body">
              <CountryForm
                country={view === 'edit' ? selectedCountry : null}
                onSaved={handleSaved}
                onCancel={() => { setView('list'); setSelectedCountry(null); }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
